import { t } from 'i18next';

import { YupTest } from 'core/types';

export const testRequiredSchema = (
  required: boolean,
  fieldLabel?: string,
  message?: string
): YupTest => [
  'required',
  message
    ? message
    : t('errorFieldCannotBeEmpty', {
        field: fieldLabel,
      }),
  (value) => !required || Boolean(value),
];
